import { render, staticRenderFns } from "./Countdown.vue?vue&type=template&id=3a5570a2&scoped=true"
import script from "./Countdown.vue?vue&type=script&lang=ts"
export * from "./Countdown.vue?vue&type=script&lang=ts"
import style0 from "./Countdown.vue?vue&type=style&index=0&id=3a5570a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5570a2",
  null
  
)

export default component.exports